import {
  ControlcenterMelcoModelsSupplier,
  SelectField,
} from "melco-shared-logic";
import { useManageSuppliers } from "../../hooks/suppliers/useManageSuppliers";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type DisplaySuppliersDropDownProps = {};

export const DisplaySuppliersDropDown: React.FC<
  DisplaySuppliersDropDownProps
> = () => {
  const { t } = useTranslation();
  const { data } = useManageSuppliers(undefined, "threads", 999999);

  const [suppliers, setSuppliers] = useState<
    ControlcenterMelcoModelsSupplier[]
  >([]);

  useEffect(() => {
    //   let temp:any = data?.sort((a,b)=>a.name.localeCompare(b.name))
    let temp: any = data?.sort((a, b) => (a.name > b.name ? 1 : -1));
    setSuppliers(temp);
  }, [data]);

  return (
    <>
      <SelectField
        name="supplier_id"
        label={t("supplierproducts.form.supplier")}
        options={(suppliers ?? []).map((supplier: any) => {
          return {
            label: supplier.name! + " - " + supplier.supplier_type,

            value: supplier.id!,
          };
        })}
        showSearch
        optionFilterProp="label"
      // onChange={(value) => callbackFn(value)}
      />
    </>
  );
};
